'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiStar = function TiStar(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm15.6 15.3l-8.8 0.9c-0.3 0.1-0.6 0.3-0.7 0.6s0 0.7 0.3 0.9c2.6 2.4 6.5 5.9 6.5 5.9 0 0-1.1 5.2-1.8 8.7-0.1 0.3 0.1 0.6 0.3 0.8 0.3 0.2 0.6 0.2 0.9 0.1 3.1-1.8 7.7-4.4 7.7-4.4s4.6 2.6 7.7 4.4c0.3 0.1 0.6 0.1 0.9-0.1 0.2-0.2 0.4-0.5 0.3-0.8-0.7-3.5-1.8-8.7-1.8-8.7l6.5-5.9c0.3-0.2 0.4-0.6 0.3-0.9s-0.4-0.5-0.7-0.6c-3.5-0.4-8.8-0.9-8.8-0.9l-3.6-8.1c-0.2-0.3-0.5-0.5-0.8-0.5s-0.6 0.2-0.8 0.5c-1.4 3.2-3.6 8.1-3.6 8.1z' })
        )
    );
};

exports.default = TiStar;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/star.js
// module id = 2038
// module chunks = 0